import React, { useEffect, useState } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { NavigationService } from '../../services/navigation/navigation-service';

export const AppLink = (props: LinkProps<unknown> & React.RefAttributes<HTMLAnchorElement>) => {
    const navigationService = new NavigationService();
    const [to, setTo] = useState<string>(props.to.toString());

    useEffect(() => {
        const url = new URL(props.to.toString(), window.location.origin);
        const impersonationUrl = navigationService.addImpersonationToUrl(url);
        setTo(impersonationUrl.pathname + impersonationUrl.search + impersonationUrl.hash);
    }, []);

    return (
        <Link {...props} to={to}>{props.children}</Link>
    );
}